package it.neckar.lizergy.model.state.processStatesClient

import it.neckar.lizergy.model.state.ProcessStatesForComponent
import it.neckar.rest.RestResponse
import it.neckar.rest.pagination.Page
import it.neckar.rest.pagination.PaginationInfo
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Response for fetching process states
 */
@Serializable
sealed interface FetchProcessStatesResponse : RestResponse<List<ProcessStatesForComponent>> {

  @Serializable
  @SerialName("good")
  data class Good(
    override val data: List<ProcessStatesForComponent>,
    override val paginationInfo: PaginationInfo,
  ) : FetchProcessStatesResponse, RestResponse.PaginatedGoodResponse<List<ProcessStatesForComponent>>

  @Serializable
  @SerialName("bad/Failed")
  data object Failed : FetchProcessStatesResponse, RestResponse.BadResponse<List<ProcessStatesForComponent>>

  companion object {
    /**
     * Helper method to create a success object - with the correct type
     */
    fun good(data: List<ProcessStatesForComponent>, paginationInfo: PaginationInfo): FetchProcessStatesResponse = Good(data, paginationInfo)
    fun good(page: Page<ProcessStatesForComponent>): FetchProcessStatesResponse = Good(page.pageElements, page.paginationInfo)

    /**
     * Helper method to create a failure object - with the correct type
     */
    fun bad(): FetchProcessStatesResponse = Failed
  }
}
